module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("plano.editor.header.file.renamePlanogram.labelRenamePlano")) + " :")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    class: {
      empty: !_vm.hasName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('footer', [_c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.hasName
    },
    on: {
      "click": _vm.renamePlano
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("plano.editor.header.file.renamePlanogram.valider")) + "\n        ")]), _vm._v(" "), _c('ClientColorButton', {
    on: {
      "click": function($event) {
        _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("plano.editor.header.file.renamePlanogram.close")) + " ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ad9ad38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/modal/modalEditPlanoName.vue
// module id = 3284
// module chunks = 0